<template>
  <div class="main-content">
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col-auto">
          <h2 class="header-title">Пользователи</h2>
        </div>
        <div class="col-auto ml-auto">
          <button
            class="btn btn-primary"
            style="white-space: nowrap"
            @click="addModalShow"
          >
            Добавить
          </button>
        </div>
      </div>
    </div>
    <!-- Content goes Here -->
    <div class="card">
      <div class="card-body">
        <template v-if="userList.length">
          <div class="row align-items-center">
            <div class="col-auto mb-2" v-if="newSearchList.length">
              <PerPageLenth
                class="mr-3"
                :page="page"
                :perPage="perPage"
                :allDataLenth="newSearchList.length"
              />
              <PerPageCount :perPage="perPage" @perPageSet="perPageSet" />
            </div>
            <div class="col-auto ml-auto mb-2">
              <div class="row">
                <div class="col-auto">
                  <div class="input-affix">
                    <i class="prefix-icon anticon anticon-search"></i>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="searchText"
                      placeholder="Поиск"
                    />
                  </div>
                </div>
                <div class="col-auto">
                  <button
                    class="btn btn-sm btn-icon btn-secondary btn-tone excel"
                    :disabled="!newSearchList.length"
                    :class="{ excelHide: !newSearchList.length }"
                    @click="downloadFile"
                  >
                    <i class="anticon anticon-file-excel"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <hr class="mt-0 mb-2" />
        </template>
        <template v-if="newSearchList.length">
          <table
            class="table table-sm table-responsive-md table-striped table-hover"
          >
            <thead class="">
              <tr>
                <th scope="col">#</th>
                <th scope="col">ФИО</th>
                <th scope="col">Email</th>
                <th scope="col">Тел.</th>
                <th scope="col" colspan="3">Роль</th>
                <th scope="col">Дата рег.</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-if="newDatalist.length">
                <tr v-for="(item, index) in newDatalist" :key="item.id">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ item.f }} {{ item.i }} {{ item.o }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.mob_number }}</td>
                  <template v-if="item.roles.length>0">
                    <td>
                      <span v-for="(t, ti) in item.roles" :key="t.id">
                        <span v-if="ti==0" :class="{'rAdmin': t.name==='Администратор'}" class="role">{{t.name}}</span>
                      </span>                      
                    </td>
                    <td>                      
                      <span v-for="(t, ti) in item.roles" :key="t.id">
                        <span v-if="ti>0" class="roles">{{t.name}}</span>
                      </span>              
                    </td>
                  </template>
                  <template v-else>
                    <td colspan="2"></td>
                  </template>
                    <td>
                      <button
                        class="btn btn-icon btn-sm btn-success btn-tone"
                        @click="editModalShow(item.id, item.roles)"
                      >
                        <i class="anticon anticon-edit"></i>
                      </button>
                    </td>

                  
                  

                  <td>{{new Date(item.created_at).toLocaleString().substring(0, 10) }}</td>
                  <td class="text-right">
                    <button
                      class="btn btn-icon btn-sm btn-danger btn-tone"
                      @click="deleteModalShow(item)"
                    >
                      <i class="anticon anticon-delete"></i>
                    </button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          <hr />
        </template>
        <div v-else class="noTdData">Нет данных</div>
        <Pagination
          :total="newSearchList.length"
          :perPage="perPage"
          @activePage="currentPage"
        />
      </div>
    </div>
    <Modal :isShow="isAddModalShow" @closeModal="addModalClose">
      <template v-slot:title>Регистрация</template>
      <template>
        <form action="#">
          <div class="form-group">
            <label class="font-weight-semibold" for="f">Фамилия:</label>
            <div class="input-affix">
              <i class="prefix-icon anticon anticon-user"></i>
              <input
                type="text"
                class="form-control form-control-sm"
                id="f"
                placeholder="Эшматов"
                v-model.trim="user.f"
                :class="[
                  { 'is-invalid': $v.user.f.$error },
                  { 'is-valid': $v.user.f.required },
                ]"
                @blur="$v.user.f.$touch()"
              />
            </div>
            <div
              class="invalid-feedback"
              v-if="!$v.user.f.required && $v.user.f.$dirty"
            >
              Это поле обязательно
            </div>
          </div>
          <div class="form-group">
            <label class="font-weight-semibold" for="i">Имя:</label>
            <div class="input-affix">
              <i class="prefix-icon anticon anticon-user"></i>
              <input
                type="text"
                class="form-control form-control-sm"
                id="i"
                placeholder="Ташмат"
                v-model.trim="user.i"
                :class="[
                  { 'is-invalid': $v.user.i.$error },
                  { 'is-valid': $v.user.i.required },
                ]"
                @blur="$v.user.i.$touch()"
              />
            </div>
            <div
              class="invalid-feedback"
              v-if="!$v.user.i.required && $v.user.i.$dirty"
            >
              Это поле обязательно
            </div>
          </div>
          <div class="form-group">
            <label class="font-weight-semibold" for="o">Отчество:</label>
            <div class="input-affix">
              <i class="prefix-icon anticon anticon-user"></i>
              <input
                type="text"
                class="form-control form-control-sm"
                id="o"
                placeholder="Полотович"
                v-model.trim="user.o"
              />
            </div>
          </div>

          <div class="form-group">
            <label class="font-weight-semibold" for="number"
              >Номер телефона:</label
            >
            <div class="input-affix">
              <i class="prefix-icon anticon anticon-phone"></i>
              <input
                type="text"
                class="form-control form-control-sm"
                id="number"
                placeholder="0123456789"
                v-model.trim="user.mob_number"
                :class="[
                  { 'is-invalid': $v.user.mob_number.$error },
                  { 'is-valid': $v.user.mob_number.required },
                ]"
                @blur="$v.user.mob_number.$touch()"
              />
            </div>
            <div
              class="invalid-feedback"
              v-if="!$v.user.mob_number.required && $v.user.email.$dirty"
            >
              Поле номер телефона обязательно
            </div>
          </div>
          <div class="form-group">
            <label class="font-weight-semibold" for="email">Email:</label>
            <div class="input-affix">
              <i class="prefix-icon anticon anticon-mail"></i>
              <input
                type="email"
                class="form-control form-control-sm"
                id="email"
                placeholder="Email"
                v-model.trim="user.email"
                :class="[
                  { 'is-invalid': $v.user.email.$error },
                  { 'is-valid': $v.user.email.required && $v.user.email.email },
                ]"
                @blur="$v.user.email.$touch()"
              />
            </div>
            <div
              class="invalid-feedback"
              v-if="!$v.user.email.required && $v.user.email.$dirty"
            >
              Поле электронной почты обязательно
            </div>
            <div
              class="invalid-feedback"
              v-if="!$v.user.email.email && $v.user.email.$dirty"
            >
              Это поле должно быть адресом электронной почты
            </div>
          </div>

          <div class="form-group">
            <label class="font-weight-semibold" for="password">Пароль:</label>
            <div class="input-affix m-b-10">
              <i class="prefix-icon anticon anticon-lock"></i>
              <input
                type="password"
                class="form-control form-control-sm"
                id="password"
                placeholder="*****"
                v-model.trim="user.password"
                :class="[
                  { 'is-invalid': $v.user.password.$error },
                  {
                    'is-valid':
                      $v.user.password.required && $v.user.password.minLength,
                  },
                ]"
                @blur="$v.user.password.$touch()"
              />
            </div>
            <div
              class="invalid-feedback"
              v-if="!$v.user.password.required && $v.user.password.$dirty"
            >
              Поле пароля почты обязательно
            </div>
            <div
              class="invalid-feedback"
              v-if="!$v.user.password.minLength && $v.user.password.$dirty"
            >
              Это поле должно быть минимум 6 символов
            </div>
          </div>

          <div class="form-group mb-0">
            <label class="font-weight-semibold" for="confirm"
              >Подтвердить пароль:</label
            >
            <div class="input-affix m-b-10">
              <i class="prefix-icon anticon anticon-lock"></i>
              <input
                type="password"
                class="form-control form-control-sm"
                id="confirm"
                placeholder="*****"
                v-model.trim="user.confirm"
                :class="[
                  { 'is-invalid': $v.user.confirm.$error },
                  {
                    'is-valid':
                      $v.user.confirm.required && $v.user.confirm.sameAs,
                  },
                ]"
                @blur="$v.user.confirm.$touch()"
              />
            </div>
            <div
              class="invalid-feedback"
              v-if="!$v.user.confirm.required && $v.user.password.$dirty"
            >
              Поле пароля почты обязательно
            </div>
            <div
              class="invalid-feedback"
              v-if="$v.user.confirm.$error && $v.user.confirm.$dirty"
            >
              Пароли должны совпадать
            </div>
          </div>
        </form>
      </template>

      <template v-slot:footer>
        <div class="d-flex justify-content-center">
          <button
            type="reset"
            class="btn btn-secondary mr-3"
            @click="addModalClose"
          >
            Отмена
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            @click.prevent="formSubmit"
          >
            Подтвердить
          </button>
        </div>
      </template>
    </Modal>
    <Modal :isShow="isEditModalShow" @closeModal="editModalClose">
      <template v-slot:title> Изменить роли </template>
      <template >
         <div class="custom-control custom-checkbox mb-4"
          v-for="item in usersRoles" :key="item.id"
         >
          <input class="custom-control-input"  type="checkbox"
            :id="'id'+item.id" 
            :value="item"     
            v-model="userItem.roles"      
          />
          <label class="custom-control-label"
            :for="'id'+item.id"
          >
            {{item.name}}
          </label>
        </div>

        
      </template>

      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-danger mr-3"
          @click="editModalClose"
        >
          Отмена
        </button>
        <button type="button" class="btn btn-primary" @click="roleEdit">
          Сохранить
        </button>
      </template>
    </Modal>

  </div>
</template>
<script>

import Pagination from "@/components/others/Pagination.vue";
import PerPageLenth from "@/components/others/PerPageLenth.vue";
import PerPageCount from "@/components/others/PerPageCount.vue";
import Modal from "@/components/others/Modal.vue";

import { validationMixin } from "vuelidate";
import { required, minLength, email, sameAs } from "vuelidate/lib/validators";

export default {
  name: "UsersAdmin",
  components: {
    Pagination,
    PerPageLenth,
    PerPageCount,
    Modal,
  },
  mixins: [validationMixin],
  data() {
    return {
      isAddModalShow: false,
      isEditModalShow: false,
      isDeleteModalShow: false,
      page: 1,
      perPage: 10,
      searchText: "",

      userItem: {
        id: null,
        roles: []
      },
      
      userList: [],
      usersRoles: [],

      user: {
        f: "",
        i: "",
        o: "",
        mob_number: "",
        email: "",
        password: "",
        confirm: "",
        status_user: 2
      },
    };
  },
  validations: {
    user: {
      f: { required },
      i: { required },
      mob_number: { required },
      email: { required, email },
      password: { required, minLength: minLength(6) },
      confirm: { required, sameAs: sameAs("password") },
    },
  },
  computed: {
    newSearchList() {
      const regEx = new RegExp(this.searchText, "i");
      return this.userList.filter((x) => x.f.match(regEx));
    },
    newDatalist() {
      return this.newSearchList.slice(
        (this.page - 1) * this.perPage,
        this.page * this.perPage
      );
    },
  },
  methods: {
    currentPage(i) {
      this.page = i;
    },
    perPageSet(count) {
      this.perPage = count;
    },
    addModalShow() {
      this.isAddModalShow = true;
    },
    addModalClose() {
      this.isAddModalShow = false;
    },
    editModalShow(id, r) {
      this.userItem.id = id
      this.userItem.roles = r.map(i=>{return {id: i.id, name: i.name}})
      this.isEditModalShow = true;
    },
    editModalClose() {
      this.userItem = {id: null,roles: []}
      this.isEditModalShow = false;
    },
    deleteModalShow() {
      this.isDeleteModalShow = true;
    },
    deleteModalClose() {
      this.isDeleteModalShow = false;
    },
    formSubmit() {
      if (this.$v.$invalid) {
        this.$v.user.$touch();
      } else {
        this.reg_user();
      }
    },
    downloadFile() {
      // let data = [
      //   {
      //     sheet: "Факультет",
      //     columns: [
      //       { label: "id", value: "id" },
      //       { label: "---", value: "short_name" },
      //       { label: "Кыргызча", value: "name_kg" },
      //       { label: "Русский", value: "name_ru" },
      //       { label: "English", value: "name_en" },
      //       { label: "Интеграция очный", value: "id_integration_oo" },
      //       { label: "Интеграция заочный", value: "id_integration_zo" },
      //     ],
      //     content: [...this.newSearchList],
      //   },
      // ];
      // let settings = {
      //   fileName: "Факультет",
      // };
      // xlsx(data, settings);
    },
    async reg_user() {
      try {
        await this.$api.others.reg_user(this.user);        
        this.addModalClose();
        this.roles();
        this.$nt("Успешно зарегистрирован", "success");
      } catch (error) {        
        this.$nt("Ошибка регистрации", "dagner");
      }
    },
    async roles() {
      try {
        const data = (await this.$api.others.roles()).data;
        this.userList = data
      } catch (error) {
        console.log(error);
      }
    },
    async role() {
      try {
        const data = (await this.$api.others.role()).data;
        this.usersRoles= data.map(i=>{return {id: i.id, name: i.name}}).sort((a,b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0))
      } catch (error) {
        console.log(error);
      }
    },
    async update_roles() {
      try {
        (await this.$api.others.update_roles({
          user_id: this.userItem.id,
          roles: this.userItem.roles.map(i=>{return i.id})
        }));   
        this.$nt("Успешно изменен", "success");    
        this.roles()
        
      } catch (error) {
        console.log(error);
      }
    },
    roleEdit(){
      this.update_roles()
      this.editModalClose()
    }
   
  },
  mounted() {
    this.$nextTick(function () {
      this.roles()
      this.role()
    });
  },
};
</script>
<style lang="scss" scoped>
td:last-child {
  word-wrap: none;
}
.role{
  font-size: .85em;
  background-color: #f57f3f;
  color: #fff;
  border-radius: 3px;
  padding: 1px 5px;
}
.role.rAdmin{
  background-color: #3f87f5;
}
.roles{
  font-size: .85em;
  background-color: #f3f3f3;
  border-radius: 3px;
  border: 1px solid #dadada;;
  padding: 1px 5px;
  margin-right: 5px;
  margin-bottom: 3px;
  display: inline-block;
  // font-weight: 500;
}
</style>
